import { render, staticRenderFns } from "./MultiEcg.vue?vue&type=template&id=795ff5da&scoped=true&"
import script from "./MultiEcg.vue?vue&type=script&lang=js&"
export * from "./MultiEcg.vue?vue&type=script&lang=js&"
import style0 from "./MultiEcg.vue?vue&type=style&index=0&id=795ff5da&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ff5da",
  null
  
)

export default component.exports